module.exports = __webpack_public_path__ + "img/roadmap_icon_01@2x.cd3d0184.png";